import { useTranslation } from "react-i18next";

import ReferralSvg from "@/assets/common/other_icons/referral.svg?react";
import useSegmentEvent from "@/hooks/useSegmentEvent";

import BaseCard, { ActionButton } from "./BaseCard";

function Referral() {
  const { t } = useTranslation(["communicate"]);
  const { sendSegmentEvent } = useSegmentEvent();

  return (
    <BaseCard
      title={t("communicate:referral.title")}
      text={t("communicate:referral.text")}
      Icon={ReferralSvg}
      orientation="vertical"
    >
      <ActionButton
        to="https://try.hellocarbo.com/programme-parrainage-carbo"
        onClick={() => sendSegmentEvent("referral_program")}
        shouldOpenNewTab
      >
        {t("communicate:referral.primaryAction")}
      </ActionButton>
    </BaseCard>
  );
}

export default Referral;
